import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationFA from "./locales/fa/translation.json";
import translationAR from "./locales/ar/translation.json";
import translationTR from "./locales/tr/translation.json";

export const languageOptions = [
  { code: "fa", label: "فارسی", flag: "🇮🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
];

export const countries = [{ code: "IR", label: "+98" }];

const resources = {
  en: { translation: translationEN },
  fa: { translation: translationFA },
  ar: { translation: translationAR },
  tr: { translation: translationTR },
};

export const normalizeLang = (lng: string) => lng?.split("-")[0];

const getDefaultLanguage = (): string => {
  const storedLang = localStorage.getItem("i18nextLng");

  if (storedLang) {
    const normalized = normalizeLang(storedLang);
    if (["fa", "en", "ar", "tr"].includes(normalized)) {
      return normalized;
    }
  }

  return "fa";
};

const initialLang = getDefaultLanguage();

const setDocumentDirection = (lng: string) => {
  const normalized = normalizeLang(lng);
  document.documentElement.dir = ["fa", "ar"].includes(normalized)
    ? "rtl"
    : "ltr";
  document.documentElement.lang = normalized;
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "fa",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

setDocumentDirection(initialLang);

i18n.on("languageChanged", (lng) => {
  const normalized = normalizeLang(lng);
  setDocumentDirection(normalized);
  localStorage.setItem("i18nextLng", normalized);
});

export const changeLanguage = async (lang: string) => {
  const normalized = normalizeLang(lang);
  await i18n.changeLanguage(normalized);
  localStorage.setItem("i18nextLng", normalized);
};

export const getCurrentLanguage = (): string => {
  return normalizeLang(i18n.language);
};

export const isRTL = (): boolean => {
  const lang = getCurrentLanguage();
  return ["fa", "ar"].includes(lang);
};

export default i18n;
